import { forwardRef } from 'react'
import SymbolIcon from './SymbolIcon'
import './IconButton.css'

const IconButton = forwardRef(function IconButton({ icon, label, ariaLabel, onClick, disabled = false, tone = 'default', variant = 'outlined', className = '', ...props }, ref) {
  return (
    <button
      {...props}
      ref={ref}
      className={`icon-button icon-button--${variant}${tone !== 'default' ? ` icon-button--${tone}` : ''}${className ? ` ${className}` : ''}`}
      type="button"
      title={label}
      aria-label={ariaLabel || label}
      data-i18n-live="1"
      onClick={onClick}
      disabled={disabled}
    >
      <SymbolIcon icon={icon} className={`icon-button__icon icon-button__icon--${icon}`} />
    </button>
  )
})

export default IconButton
